import React from 'react'
import PropTypes from 'prop-types'
import Mask from 'vanilla-masker'
import classNames from 'classnames'

const InputNumber = (props) => {
  const {
    id,
    type = 'text',
    name,
    value,
    onChange,
    onKeyPress = () => {},
    onKeyDown = () => {},
    onKeyUp = () => {},
    onBlur,
    label,
    checked,
    disabled = false,
    minLength,
    maxLength,
    min,
    max,
    className,
    placeholder,
    separator = ',',
    typeMask = '',
  } = props

  const handleChange = (event) => {
    const str = event.target.value.replace(/[^\d]+/g, '')

    let mask
    switch (str.length) {
      case 1:
        mask = `9${typeMask}`
        break
      case 2:
        mask = `9${separator}9${typeMask}`
        break
      case 3:
        mask = `9${separator}99${typeMask}`
        break
      case 4:
        mask = `99${separator}99${typeMask}`
        break
      case 5:
        mask = `999${separator}99${typeMask}`
        break
      default:
        mask = `${typeMask}`
        break
    }

    event.target.value = Mask.toPattern(event.target.value, mask)

    onChange(event)
  }

  const handleBlur = (event) => {
    /* istanbul ignore else */
    if (onBlur) {
      onBlur(event)
    }
  }

  const handleKeyPress = (event) => {
    /* istanbul ignore else */
    if (onKeyPress) {
      onKeyPress(event)
    }
  }

  const handleKeyDown = (event) => {
    /* istanbul ignore else */
    if (onKeyDown) {
      onKeyDown(event)
    }
  }

  const handleKeyUp = (event) => {
    /* istanbul ignore else */
    if (onKeyUp) {
      onKeyUp(event)
    }
  }

  const inputClass = classNames({
    input: type !== 'radio' && type !== 'checkbox',
  })
  return (
    <span>
      <input
        type={type}
        name={name}
        id={id}
        className={`${inputClass} ${className}`}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        checked={checked}
        disabled={disabled}
        minLength={minLength}
        maxLength={maxLength}
        min={min}
        max={max}
        placeholder={placeholder}
      />

      {label && (
        <label htmlFor={id} className='label'>
          {label}
        </label>
      )}
    </span>
  )
}

InputNumber.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.any,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  label: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  separator: PropTypes.string,
  typeMask: PropTypes.string,
}

export default InputNumber
